import { Box, Grid } from "@mui/material";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import {
  MdOutlineDownloadForOffline,
  MdOutlineFileUpload,
} from "react-icons/md";
import CancelIcon from "@mui/icons-material/Cancel";
import * as XLSX from "xlsx/xlsx.mjs";
import { useNavigate } from "react-router-dom";
import Web3 from "web3";

import { writeContract, waitForTransactionReceipt } from "@wagmi/core";
import config from '../../Config/WagmiConfig';

import AuthBtn from "../../Components/Button/AuthBtn";
import OZK_logo from "../../Assets/images/logo.svg";
import WhitelistingTable from "./WhitelistingTable";
import CustomInput from "../../Components/Input/CustomInput";
import TopNavBar from "../../Components/TopBar/Navbar";
import ActionModal from "../../Components/Modal/ActionModal";
import Walletaction from "../../Components/walletaction/Walletaction";
import PopUpModal from "../../Components/walletaction/PopupModal";

import CustomModal from "../../Components/Modal/CustomModal";
import CustomText_input from "../../Components/Input/CustomText_input";
import GradiantButton from "../../Components/Button/GradiantButton";

import { useWriteContract,useWaitForTransactionReceipt, useAccount } from "wagmi"

import VestingABI from "../../ContractABI/Vesting.json";
import PrivateSaleABI from "../../ContractABI/OZKPrivateSale.json";

import {
  REACT_APP_OZK_VESTING,
  REACT_APP_CHAIN_ID,
  REACT_APP_ADMIN_WHITELIST_ROLE,
  REACT_APP_PRIVATE_SALE,
  REACT_APP_RPC_URL, REACT_APP_FUNDS_OWNER_ROLE, REACT_APP_ADMIN_ROLE,
} from '../../Config/Config';
import PresaleTable from '../ICOAdmin/PresaleTable';
import ICOAdminWithdraw from '../ICOAdmin/ICOAdminWithdraw';

const VestingAdmin = () => {
  const navigate = useNavigate();
  const [DepositModal, setDepositModal] = useState(false);
  const [ConfirmModal, setConfirmModal] = useState(false);
  const [DepAmount, setDepAmount] = useState("");

  const [popupmodal, setpopupmodal] = useState(false);
  const [poptext, setpoptext] = useState("");

  const [WalletActionModal, setWalletActionModal] = useState(false);
  const [Loader1, setLoader1] = useState(false);
  const [Loader2, setLoader2] = useState(false);
  const [Loader3, setLoader3] = useState(false);


  const [addinvestors, setaddinvestors] = useState("");
  const [investamount, setinvestamount] = useState("");
  const [investtype, setinvesttype] = useState("");
  const [removeinvestoraddress, setremoveinvestoraddress] = useState("");

  const [Csvfilename, setCsvfilename] = useState("");
  const [csvfilwallet,setcsvfilwallet]=useState([])

  const [WhiteList, setWhiteList] = useState([]);

  const [WalletTokenBalance, setWalletTokenBalance] = useState("");
  const [Hashlink,setHashlink]= useState("");

  var formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  });

  const { address, isConnected } = useAccount();
  const web3 = new Web3(REACT_APP_RPC_URL)

  useEffect(()=>{
    if(isConnected && address){
        Ownercheck();
        getWhiteList();
    } else{
      navigate("/")
    }
  },[isConnected, address])

  const { data: hash, error, isPending } = useWriteContract()

  useEffect(()=>{
  
    if(error != null){
      setLoader1(false);
      setLoader2(false);
      setLoader3(false);
      setWalletActionModal(false);
    }

    if(isPending){
      setWalletActionModal(true);
      setLoader1(true);
      setLoader2(true);
      setLoader3(true);
    }

  },[error,isPending])

  const { isLoading: isConfirming, isSuccess: isConfirmed } = useWaitForTransactionReceipt({hash})

  // useEffect(()=>{
  //
  //   if(isConfirmed){
  //     setLoader1(false);
  //     setLoader2(false);
  //     setLoader3(false);
  //     setWalletActionModal(false);
  //
  //     TokenBalance()
  //     TransactionsHistory()
  //     FetchTransactionHistory()
  //     IcoandvestingDates()
  //
  //
  //
  //   }
  //
  // },[isConfirming,isConfirmed])



  const { data: depositHash, error: depositError, isPending: isDepositPending, writeContract: writeDepositContract } = useWriteContract();
  // useEffect(()=>{
  //
  //   if(depositError != null){
  //     setLoader1(false);
  //     setLoader2(false);
  //     setLoader3(false);
  //     setWalletActionModal(false);
  //   }
  //
  //   if(isDepositPending){
  //     setWalletActionModal(true);
  //     setLoader2(true)
  //     setLoader3(true)
  //     setLoader1(false);
  //   }
  //
  //   if(!isDepositPending){
  //     setLoader2(false);
  //   }
  //
  // },[depositError,isDepositPending])

  const { isLoading: isDepositConfirming, isSuccess: isDepositConfirmed } = useWaitForTransactionReceipt({ hash: depositHash });
  // useEffect(()=>{
  //
  //   if(isDepositConfirmed){
  //     setLoader2(false);
  //     setLoader3(false);
  //     setWalletActionModal(false);
  //
  //     TokenBalance()
  //     TransactionsHistory()
  //     FetchTransactionHistory()
  //     IcoandvestingDates()
  //
  //   }
  // }, [isDepositConfirming, isDepositConfirmed])


  const Ownercheck =async()=>{
    if(address){
      try{
        const PrivateSaleContract = new web3.eth.Contract(PrivateSaleABI,REACT_APP_PRIVATE_SALE)
        const hasRole = await PrivateSaleContract.methods?.hasRole(REACT_APP_ADMIN_WHITELIST_ROLE, address).call();
        const hasRoleFundsOwner = await PrivateSaleContract.methods?.hasRole(REACT_APP_FUNDS_OWNER_ROLE, address).call();
        const hasRoleAdmin = await PrivateSaleContract.methods?.hasRole(REACT_APP_ADMIN_ROLE, address).call();

        if(hasRole || hasRoleFundsOwner || hasRoleAdmin){
          TokenBalance()
        } else {
          navigate("/");
        }
      }catch(err){
        console.log("ErrorOwnercheck==>",err)
      }
    }
  }

  const TokenBalance = async()=>{
    try{
      const tokenBalance = await web3.eth.getBalance(address);
      const tokenavailable = await web3.utils.fromWei(tokenBalance?.toString(), "ether");
    
      setWalletTokenBalance(tokenavailable);

    }catch(err){
      console.log("ErrorTokenBalance==>",err)
    }
  }

  const getWhiteList = async()=>{
    console.log("GET WHITELIST");
    try{
      const PrivateSaleContract = new web3.eth.Contract(PrivateSaleABI,REACT_APP_PRIVATE_SALE)
      const whitelist = await PrivateSaleContract.methods?.getWhitelist().call();

      setWhiteList(whitelist);

    }catch(err){
      console.log("ErrorTokenBalance==>",err)
    }
  }

  // const FetchTransactionHistory = async () => {
  //   //fetch withdraw transaction should be here
  //   try {
  //     if (web3 != null) {
  //
  //       const result = await axios.post(
  //         REACT_APP_RPC_URL,
  //         {
  //           jsonrpc: "2.0",
  //           id: 1,
  //           method: "eth_getLogs",
  //           params: [
  //             {
  //               address: REACT_APP_OZK_VESTING,
  //               topics: [
  //                 "0x1b4ecc852b95883fb347c6413c597bdbd66606a22ab60b54622ff1ec5a044be2",
  //               ],
  //               fromBlock: "0x0",
  //               toBlock: "latest",
  //             },
  //           ],
  //         },
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );
  //       const resultArray = result.data.result;
  //       const reversedList = resultArray.map((e, i, a) => a[a.length - 1 - i]);
  //       const transactionHistory = [];
  //       reversedList.forEach((event) => {
  //         var data1 =web3.eth.abi.decodeLog(
  //           [
  //             {
  //               indexed: false,
  //               internalType: "address",
  //               name: "account",
  //               type: "address",
  //             },
  //             {
  //               indexed: false,
  //               internalType: "uint",
  //               name: "amount",
  //               type: "uint",
  //             },
  //           ],
  //           event.data
  //         );
  //
  //         const transactionHash = event.transactionHash;
  //         const amount = parseFloat(web3.utils.fromWei(data1.amount?.toString(),"ether")).toFixed(2);
  //
  //         var yourNumber = parseInt(event.blockTimestamp, 16) * 1000;
  //
  //         const sorttime = Number(yourNumber);
  //         const time = String(new Date(yourNumber)).slice(4, 21);
  //         const transaction = {
  //           useraddress: data1.account,
  //           transactionHash: transactionHash,
  //           amount,
  //           time: time,
  //           timess: sorttime,
  //         };
  //         transactionHistory.push(transaction);
  //       });
  //
  //       setlists(transactionHistory);
  //     }
  //   } catch (e) {
  //     console.log(e, "error");
  //   }
  // };

  // const TransactionsHistory = async () => {
  //   try {
  //     const PrivateSaleContract = new web3.eth.Contract(PrivateSaleABI,REACT_APP_PRIVATE_SALE)
  //
  //     const resultUsd = await axios.post(
  //       REACT_APP_RPC_URL,
  //       {
  //         jsonrpc: '2.0',
  //         id: 1,
  //         method: 'eth_getLogs',
  //         params: [
  //           {
  //             address: REACT_APP_PRIVATE_SALE,
  //             topics: [
  //               REACT_APP_BUY_USD_TOPIC0,
  //             ],
  //             fromBlock: web3.utils.numberToHex(7496448),
  //             toBlock: 'latest',
  //           },
  //         ],
  //       },
  //       {
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //       },
  //     );
  //
  //     const resultUsdArray = resultUsd.data.result;
  //
  //     const reversedUsdList = resultUsdArray.map((e, i, a) => a[a.length - 1 - i]);
  //
  //     const result = await axios.post(
  //       REACT_APP_RPC_URL,
  //       {
  //         jsonrpc: "2.0",
  //         id: 1,
  //         method: "eth_getLogs",
  //         params: [
  //           {
  //             address: REACT_APP_PRIVATE_SALE,
  //             topics: [
  //               REACT_APP_BUY_ETH_TOPIC0,
  //             ],
  //             fromBlock: web3.utils.numberToHex(7496448),
  //             toBlock: 'latest',
  //           },
  //         ],
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );
  //
  //     const resultArray1 = result.data.result;
  //     const reversedList1 = resultArray1.map((e, i, a) => a[a.length - 1 - i]);
  //
  //     const transactionHistory = [];
  //
  //     await Promise.all(
  //       reversedUsdList.map(async (event, i) => {
  //         const block = await web3.eth.getBlock(web3.utils.hexToNumber(event.blockNumber));
  //         const blockTime = timeconvert( Number(block.timestamp));
  //         const date = new Date(blockTime.slice(0, 24));
  //         const timeToNumber = Math.floor(date.getTime());
  //
  //         const data1 = web3.eth.abi.decodeLog(
  //           [
  //             { indexed: true, internalType: 'address', name: 'user', type: 'address' },
  //             { indexed: false, internalType: 'uint256', name: 'amount', type: 'uint256' },
  //           ],
  //           event.data, // Contains non-indexed parameters
  //           event.topics.slice(1) // Exclude topic0 (event signature hash)
  //         );
  //
  //         const userAddress = data1.user;
  //           const transactionHash = event.transactionHash;
  //           // Fetch transaction receipt
  //           const receipt = await web3.eth.getTransactionReceipt(transactionHash);
  //           // Decode logs
  //           let tokenAmount = 0;
  //           const vestedEventABI = [
  //             { indexed: true, internalType: 'address', name: 'user', type: 'address' },
  //             { indexed: false, internalType: 'uint256', name: 'amountAdded', type: 'uint256' },
  //             { indexed: false, internalType: 'uint256', name: 'totalAmount', type: 'uint256' },
  //           ];
  //           receipt.logs.forEach((log) => {
  //             if (log.topics[0] === REACT_APP_VESTED_TOPIC0) {
  //               // Decode Vested event
  //               const vestedData = web3.eth.abi.decodeLog(
  //                 vestedEventABI,
  //                 log.data,
  //                 log.topics.slice(1) // Skip topic0 (event signature hash)
  //               );
  //               tokenAmount = web3.utils.fromWei(vestedData.amountAdded, 'ether');
  //             }
  //           });
  //
  //           const saleType1 = 'USD';
  //
  //           const transaction = {
  //             transactionHash,
  //             useraddress: userAddress,
  //             amount: tokenAmount,
  //             saleType1,
  //             index1: i + 1,
  //             date: timeToNumber,
  //           };
  //           transactionHistory.push(transaction);
  //       }),
  //       reversedList1.map(async (event, i) => {
  //         const block = await web3.eth.getBlock(web3.utils.hexToNumber(event.blockNumber));
  //         const blockTime = timeconvert( Number(block.timestamp));
  //         const date = new Date(blockTime.slice(0, 24));
  //         const timeToNumber = Math.floor(date.getTime());
  //
  //         const data1 = web3.eth.abi.decodeLog(
  //           [
  //             { indexed: true, internalType: 'address', name: 'user', type: 'address' },
  //             { indexed: false, internalType: 'uint256', name: 'amount', type: 'uint256' },
  //           ],
  //           event.data, // Contains non-indexed parameters
  //           event.topics.slice(1) // Exclude topic0 (event signature hash)
  //         );
  //
  //         const userAddress = data1.user;
  //
  //           const transactionHash = event.transactionHash;
  //           // Fetch transaction receipt
  //           const receipt = await web3.eth.getTransactionReceipt(transactionHash);
  //           // Decode logs
  //           let tokenAmount = 0;
  //           const vestedEventABI = [
  //             { indexed: true, internalType: 'address', name: 'user', type: 'address' },
  //             { indexed: false, internalType: 'uint256', name: 'amountAdded', type: 'uint256' },
  //             { indexed: false, internalType: 'uint256', name: 'totalAmount', type: 'uint256' },
  //           ];
  //           receipt.logs.forEach((log) => {
  //             if (log.topics[0] === REACT_APP_VESTED_TOPIC0) {
  //               // Decode Vested event
  //               const vestedData = web3.eth.abi.decodeLog(
  //                 vestedEventABI,
  //                 log.data,
  //                 log.topics.slice(1) // Skip topic0 (event signature hash)
  //               );
  //               tokenAmount = web3.utils.fromWei(vestedData.amountAdded, 'ether');
  //             }
  //           });
  //
  //           const saleType1 = 'ETH';
  //
  //           const transaction = {
  //             transactionHash,
  //             useraddress: userAddress,
  //             amount: tokenAmount,
  //             saleType1,
  //             index1: i + 1,
  //             date: timeToNumber,
  //           };
  //           transactionHistory.push(transaction);
  //       })
  //     );
  //
  //     // const getUniqueListBy = (transactionHistory, key) => {
  //     //   return [...new Map(transactionHistory.map((item) => [item[key], item])).values(),];
  //     // };
  //     //
  //     // const arr2 = getUniqueListBy(transactionHistory, "useraddress");
  //     const values = transactionHistory.sort((a, b) => b.timess - a.timess);
  //
  //
  //     setWhiteList(values);
  //
  //   } catch (error) {
  //     console.log("error", error);
  //   }
  // };



  const cancelfile = () => {
    setcsvfilwallet([])
    setCsvfilename("");
  };

  const DepositValidation = () => {
    if (DepAmount.trim().length == 0) {
      toast.warn("Please Enter a Deposit Amount");
      return;
    }
    if (DepAmount === 0) {
      toast.warn("Please Enter a Deposit Amount");
      return;
    }
    setConfirmModal(true);
    setDepositModal(false);
  };

  const CheckinScan = () => {
    setWalletActionModal(false);
  };

  const ClosePopupModal = async () => {
    setpoptext("");
    setpopupmodal(false);
  };

  const AddInvestorFile = (e) => {
    var file = e.target.files[0];
    if (file) {
      let extension = "." + file.name.split(".").pop();
      if (extension == ".xlsx" || extension == ".csv" || extension == ".xls") {
        const reader = new FileReader();
        reader.fileName = file.name; // file came from a input file element. file = el.files[0];
        let newData = [];
        reader.onload = async (e) => {
          const data1 = e.target.result;
          const workbook = XLSX.read(data1, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const json = XLSX.utils.sheet_to_json(worksheet, { raw: false });
          console.log("json", json);
          setCsvfilename(e.target.fileName);
          if (json) {
            Promise.all(
              json.map((item) => {
                console.log("item==>",item)
                  const amounts = item?.amount ? item?.amount : item.Amount
                  const amount = web3.utils.toWei(amounts?.toString(),"ether")
                  newData.push(
                    item?.wallet ? item?.wallet : item.Wallet,
                  );
              })
            );
              console.log("newData==>",newData)
              setcsvfilwallet(newData);
              setCsvfilename(e.target.fileName);
          }
        };
        reader.readAsArrayBuffer(e.target.files[0]);
      } else {
        setpoptext("Upload XLSX or CSV File");
        setpopupmodal(true);
      }
    } else {
      setpoptext("Select XLSX or CSV File");
      setpopupmodal(true);
    }
  };

  const addInvestorcsv = async () => {
    if (web3 && csvfilwallet.length > 0) {
      const data = csvfilwallet;
      setWalletActionModal(true);
      setLoader1(true);
      setLoader2(true);
      setLoader3(true);
      console.log({data});
      try {
        const tx = await writeContract(config, {
          address: REACT_APP_PRIVATE_SALE,
          abi: PrivateSaleABI,
          functionName: "whitelistAdd",
          args: [data], 
          value: 0,
        });
        
        await waitForTransactionReceipt(config, {confirmation: 1, hash: tx});
        
        getWhiteList();

        setHashlink("");
        setcsvfilwallet([]);
        setCsvfilename("");
        setLoader1(false);
        setLoader2(false);
        setLoader3(false);
        setWalletActionModal(false);
      } catch (err) {
        console.log("ErrorinaddInvestor==>",err);
        setWalletActionModal(false);
        setLoader1(false);
        setLoader2(false);
        setLoader3(false);
      }
    } else if (csvfilwallet.length == 0) {
     
      setpoptext("Please Upload Investor Details")
      setpopupmodal(true)
    } else {
      
      setpoptext("Please Connect Wallet")
      setpopupmodal(true)
    }
  
  };

  const addInvestor = async () => {
    if (web3 && addinvestors) {
      const isAddress = web3.utils.isAddress(addinvestors);
      try {
        if (addinvestors === "") {
          
          setpoptext("ADD INVESTOR ADDRESS")
          setpopupmodal(true)
        } else if (isAddress) {
            const PrivateSaleContract = new web3.eth.Contract(PrivateSaleABI,REACT_APP_PRIVATE_SALE)
            const isAlreadyWhitelisted = await PrivateSaleContract.methods.checkWhitelisted(addinvestors).call();
            if (!isAlreadyWhitelisted) {
             const tx = await writeContract(config, {
                address: REACT_APP_PRIVATE_SALE,
                abi: PrivateSaleABI,
                functionName: "whitelistAdd",
                args: [[addinvestors]],
              });
              setHashlink("");
              
              await waitForTransactionReceipt(config, {confirmation: 1, hash: tx});
              
              getWhiteList();

              setaddinvestors("");
              setinvestamount("");
              setinvesttype("");
            } else {
              setpoptext("INVESTOR ALREADY EXISTING")
              setpopupmodal(true)
            }
          } else {
            setpoptext("ENTER VALID INVESTOR ADDRESS")
            setpopupmodal(true)
          }
      } catch (e) {
        console.log("ErrorinaddInvestor==>",e);
        
      }
    }
  };

  const InvestorRemove = async () => {
    if (removeinvestoraddress !== "") {
      const isAddress = web3.utils.isAddress(removeinvestoraddress);
      if (isAddress) {
        try {
          const tx = await writeContract(config, {
            address: REACT_APP_PRIVATE_SALE,
            abi: PrivateSaleABI,
            functionName: "whitelistRemove",
            args: [[removeinvestoraddress]],
          });
          console.log({tx});
          
          await waitForTransactionReceipt(config, {confirmation: 1, hash: tx});
          
          getWhiteList();
          
          setHashlink("");
          setremoveinvestoraddress("");
        } catch (e) {
          console.log("Error in InvestorRemove", e);
        }
      } else{
        setpoptext("ENTER VALID INVESTOR ADDRESS")
        setpopupmodal(true)
      }
    } else {
      setpoptext("Please Enter Address")
      setpopupmodal(true)
    }
  };

  const DepositOZK = async ()=>{

    if(window?.ethereum?.networkVersion != REACT_APP_CHAIN_ID){
      setpoptext("Switch Your Network To OZK Testnet")
      setpopupmodal(true)
      return;
    }

    try {

      const token1 = web3.utils.toWei(DepAmount.toString(),"ether");
      console.log("token1==>",token1)

      writeDepositContract({
        address: REACT_APP_OZK_VESTING,
        abi: VestingABI,
        functionName: "deposit",
        args: [], 
        value: token1,
      });

      setDepAmount("");

    }catch(err){
      console.log("Error_in_DepositOZK==>",err)
    }

  }

  const DepositAmount = async () => {

    if(window?.ethereum?.networkVersion != REACT_APP_CHAIN_ID){
      setpoptext("Switch Your Network To OZK Testnet")
      setpopupmodal(true)
      return;
    }

    try {
      setConfirmModal(false);
      if (Number(WalletTokenBalance) >= Number(DepAmount)) {

        DepositOZK()
      } else {
        setpoptext("INSUFFICIENT BALANCE IN WALLET")
        setpopupmodal(true)
      }
    } catch(err) {
      console.log("Error in deposits ==>",err)
      setDepAmount("");
      setConfirmModal(false);
      setWalletActionModal(false);
      setLoader1(false);
      setLoader2(false);
      setLoader3(false);
    }
    setLoader1(false);
    setLoader2(false);
    setLoader3(false);
    setWalletActionModal(false);
  };

  return (
    <Grid
      container
      sm={12}
      xs={12}
      display={"flex"}
      flexDirection={"row"}
      alignItems={"flex-start"}
      justifyContent={"center"}
      className={"vestingadminBG"}
    >
      <Grid container position={"fixed"} zIndex={100}>
        <TopNavBar />
      </Grid>
          <Grid
            container
            sm={11}
            xs={12}
            display={"flex"}
            justifyContent={{ sm: "space-between", xs: "center" }}
            className={"main_position"}
          >
            
            <Grid
              container
              lg={12}
              display={"flex"}
              flexDirection={"row"}
              flexWrap={"wrap"}
              alignItems={{ sm: "stretch", xs: "center" }}
              justifyContent={{ sm: "space-between", xs: "center" }}
              className="p-3"
            >
              <Grid
                container
                lg={7.9}
                sm={7.9}
                className="saleadmin_table_layer mb-3"
                display={"flex"}
                flexDirection={"column"}
                flexWrap={"wrap"}
                alignItems={"flex-start"}
                justifyContent={"flex-start"}
              >
                <Box className="w-100">
                  <WhitelistingTable WhiteListing={WhiteList}
                                     reloadwhitelist={getWhiteList}
                  />
                </Box>
              </Grid>
        <Grid
          container
          lg={4}
          md={4}
          sm={12}
          xs={12}
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"center"}
          alignItems={"space-between"}
          flexWrap={"wrap"}
          className="py-2 px-2"
        >
          <Grid
            item
            lg={12}
            xs={12}
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            justifyContent={"space-between"}
       
          >
            <Box className="vesting_common_layer2 w-100 p-3 ">
              <h5 className="text-center w-100">Add Investor</h5>
              <p className="py-2">Investor Address</p>
              <CustomInput
                isBorder={true}
                placeholder={"Enter Address"}
                borderColor={"#5F4C3E"}
                Value={addinvestors}
                handleInput={(e) => setaddinvestors(e)}
              />

              <AuthBtn text="ADD" width={"80%"} className="mt-4"
                borderColor={"#FFED8C"}
                btnTextColor={"#FFED8C"}
                btnColor={"#000000"}
                onClick={()=>{addInvestor()}} 
              />
            </Box>
            

            <Box className="vesting_common_layer2 w-100 p-3 mt-3">
              <p className="py-2">Add Investor using CSV</p>
              <Grid
                container
                className="w-100"
                display={"flex"}
                flexDirection={"row"}
                alignItems={"center"}
                justifyContent={"center"}
              >
                {Csvfilename ? (
                  <Grid
                    container
                    alignItems={"center"}
                    flexDirection={"row"}
                    justifyContent={"space-between"}
                    lg={12}
                    md={12}
                    sm={21}
                  >
                    <label
                      className="btn btn-0 m-0 d-flex w-100"
                      style={{
                        cursor: "default",
                        justifyContent: "space-between",
                        border:"1px solid #FFED8C"
                      }}
                    >
                      <p className="text-capitalize">
                        <MdOutlineFileUpload size={"20px"} color={"#FFED8C"} />{" "}
                        {Csvfilename}
                      </p>

                      {/* <Grid item lg={2} className=""> */}
                      <CancelIcon
                        size="large"
                        onClick={() => cancelfile()}
                        style={{ color: "red", cursor: "pointer" }}
                      />
                      {/* </Grid> */}
                    </label>
                  </Grid>
                ) : (
                  <Grid item lg={10}>
                    <label
                      className="btn btn-0 rounded d-flex w-100 mt-2"
                      htmlFor={"contained_file"}
                      style={{ border: "1px solid #5F4C3E",backgroundColor: "rgba(226, 226, 226, 0.2)" }}
                    >
                      <p className="text-center w-100">
                        <MdOutlineFileUpload size={"22px"} color={"#FFED8C"} /> Upload CSV
                      </p>
                    </label>
                    <input
                      type="file"
                      accept=".xlsx, .xls, .csv"
                      id={"contained_file"}
                      style={{ display: "none" }}
                      placeholder="Upload"
                      value={""}
                      onChange={(e) => AddInvestorFile(e)}
                    />
                  </Grid>
                )}

                <Grid item lg={10} className="mt-2">
                  <AuthBtn
                    text="ADD"
                    width={"100%"}
                    borderColor={"#FFED8C"}
                    btnTextColor={"#FFED8C"}
                    btnColor={"#000000"}

                    onClick={() => {
                      addInvestorcsv();
                    }}
                  />
                </Grid>
              </Grid>

              <Grid
                item
                display={"flex"}
                className="mt-2"
                sx={{ cursor: "pointer" }}
              >
                <a style={{color:"#fff"}} href="https://skyclinic.s3-ap-south-1.amazonaws.com/NFTs/OCOWalletslists.xlsx" download>
                  <p>Download Template <MdOutlineDownloadForOffline className="mx-2" color="#fff" size={"20px"} /></p>
                </a>
              </Grid>
            </Box>
          </Grid>
          <Grid
            item
            lg={12}
            xs={12}
            display={"flex"}
            flexDirection={"column"}
            alignItems={"center"}
            justifyContent={"center"}
            flexWrap={"wrap"}
            // className="walletAction_Card p-3 mt-3 "
            className="mt-2"
          >
            <Box className="vesting_common_layer2 w-100 p-3">
              <h5 className="text-center w-100">Remove Investor</h5>
              <p className="py-2">Investor Address</p>
              <CustomText_input
                placeholder="Enter Remove Adress"
                Value={removeinvestoraddress}
                height={"40px"}
                HandleInput={(e) => setremoveinvestoraddress(e)}
              />
              <Grid
                container
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
              >
                <AuthBtn text="REMOVE" width={"80%"} className="mt-4"
                  borderColor={"#FFED8C"}
                  btnTextColor={"#FFED8C"}
                  btnColor={"#000000"}
                  onClick={() => { InvestorRemove() }} 
                />
              </Grid>
            </Box>
          </Grid>
        </Grid>
        </Grid>
        <div className="p-2" />
        <CustomModal
          open={DepositModal}
          setOpen={setDepositModal}
          modalTitle={<h5>Deposit</h5>}
          width={{sm:"30%",xs:"90%"}}
          modalContent={
            <Grid
              container
              lg={12}
              display={"flex"}
              flexDirection={"column"}
              alignItems={"flex-start"}
              justifyContent={"flex-start"}
            >
              <Grid container lg={12}>
                <p>Available Token in Wallet</p>
                <Grid
                  container
                  lg={12}
                  className="mt-2 p-2 "
                  display={"flex"}
                  flexDirection={"row"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                  bgcolor={"#000"}
                  sx={{ borderRadius: "8px",border:"1px solid #5F4C3E" }}
                >
                  <Grid
                    display={"flex"}
                    flexDirection={"row"}
                    alignItems={"center"}
                  >
                    <img
                      src={OZK_logo}
                      alt="coin"
                      style={{ height: "25px", width: "25px" }}
                    />
                    <p className="mx-2">{formatter.format(WalletTokenBalance)}</p>
                  </Grid>
                  <Grid
                    display={"flex"}
                    flexDirection={"row"}
                    alignItems={"center"}
                  >
                    <img
                      src={OZK_logo}
                      alt="coin"
                      style={{ height: "25px", width: "25px" }}
                    />
                    <p className="mx-2">OZK</p>
                  </Grid>
                </Grid>
              </Grid>
              <Grid container lg={12} className="mt-3">
                <p className="py-2">Deposit Token</p>
                <CustomText_input
                  placeholder={"Enter Deposit Amount"}
                  bgcolor={"rgba(0, 0, 0, 0.32)"}
                  isBorder={true}
                  borderColor={"#fff"}
                  Value={DepAmount}
                  HandleInput={(e) => setDepAmount(e)}
                  inputType={"number"}
                  maxLength={15}
                  icon={
                    <Grid
                      display={"flex"}
                      flexDirection={"row"}
                      alignItems={"center"}
                    >
                      <img
                        src={OZK_logo}
                        alt="coin"
                        style={{ height: "25px", width: "25px" }}
                      />
                      <p className="mx-2">OZK</p>
                    </Grid>
                  }
                />
                <div className="p-3" />
                <Grid
                  item
                  lg={12}
                  display={"flex"}
                  flexDirection={"row"}
                  justifyContent={"center"}
                >
                  <GradiantButton
                    text={"DEPOSIT"}
                    width={"100%"}
                    borderColor={"#FFED8C"}
                    btnTextColor={"#FFED8C"}
                    btnColor={"#000000"}
                    onClick={() => DepositValidation()}
                  />
                </Grid>
              </Grid>
            </Grid>
          }
        />
        <ActionModal
          open={ConfirmModal}
          setOpen={setConfirmModal}
          modalTitle={<h5>Sure you want to Deposit ?</h5>}
          modalContent={
            <Grid
              container
              lg={12}
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              justifyContent={"center"}
            >
              <img
                src={OZK_logo}
                alt="verce"
                style={{ height: "50px", width: "50px" }}
              />
              <h3 className="mx-2 mt-2">{DepAmount}</h3>
              <Grid
                container
                lg={12}
                display={"flex"}
                flexDirection={"row"}
                alignItems={"center"}
                justifyContent={"center"}
                className="mt-4"
              >
                <Grid item lg={4}>
                  <AuthBtn
                    btnColor={"transparent"}
                    btnTextColor="#FFF"
                    text={"CANCEL"}
                    borderColor={"#ffff"}
                    width="90%"
                    onClick={() => setConfirmModal(false)}
                  />
                </Grid>
                <div className="p-2" />
                <Grid item lg={4}>
                  <AuthBtn
                    text={"CONFIRM"}
                    borderColor={"#FFED8C"}
                    btnTextColor={"#FFED8C"}
                    btnColor={"#000000"}
                    width="90%"
                    onClick={() => DepositAmount()}
                  />
                </Grid>
              </Grid>
            </Grid>
          }
        />

        <Walletaction
          WalletActionModal={WalletActionModal}
          Loader1={Loader1}
          Loader2={Loader2}
          Loader3={Loader3}
          hash={Hashlink}
          handleClose={CheckinScan}
          isCompleted={Hashlink}
        />

        <PopUpModal
          popupmodal={popupmodal}
          poptext={poptext}
          handleClose={ClosePopupModal}
        />
      </Grid>
    </Grid>
  );
};

export default VestingAdmin;
